import { HiOutlineDocumentText } from "react-icons/hi2";

import classes from "./PrintPrompt.module.css";
import Print from "./Print";

const PrintPrompt = () => {
  return (
    <div className={classes.prompt}>
      <p className={classes.heading}>
        <HiOutlineDocumentText className={classes.headingIcon} aria-hidden />
        Print your transaction receipt
      </p>
      <div className={classes.print}>
        <Print />
      </div>
    </div>
  );
};

export default PrintPrompt;
